import { useRef, useState } from "react";
import useStore from "./store";
import Home from "./pages/Home";
// import VideoPortal from "./components/VideoPortal";
import { observer } from "mobx-react-lite";
import tu1 from "./assets/img/tu2.jpg";

function App() {
  // const [showPortal, setShowPortal] = useState(false);

  const [videoObj, setVideoObj] = useState({
    posterImg: tu1,
    src: "https://vodpub6.v.news.cn/yqfbzx-original/20221006/202210069a1ecc0cab5a49808494bd40fdf7b6a0_701107764a974bfc8ba5f209cff1b039.mp4",
  });

  const { playStore } = useStore();

  // console.log(playStore);

  // const showPortalHandler = () => {
  //   // console.log(12);
  //   // setShowPortal(true);
  //   playStore.setPlay(1);
  // };

  const tempHandler = (posterImg, src, id) => {
    // console.log(posterImg, src);
    setVideoObj({
      posterImg: posterImg,
      src: src,
    });
    playStore.setPlay(id);
  };

  // const xPortalHandler = () => {
  //   // setShowPortal(false);
  //   playStore.setPlay(0);
  // };

  // const topVideoPauseHandler = () => {};

  const pageView = useRef();

  const [myH, setMyH] = useState(460);

  const wheelHandler = () => {
    window.scrollTo(0, myH);
  };

  const getHeight = (value) => {
    setMyH(value);
  };

  return (
    <div className="App" ref={pageView}>
      <Home
        // onPortal={showPortalHandler}
        onTemp={tempHandler}
        // onTop={topVideoPauseHandler}
        videoObj={videoObj}
        onWheel={wheelHandler}
        onHeight={getHeight}
      />
      {/* {showPortal ? (
        <VideoPortal onX={xPortalHandler} videoObj={videoObj} />
      ) : null} */}
    </div>
  );
}

export default observer(App);
